import { ApiParameter, get, request } from "@insite/client-framework/Services/ApiService";
 
const credAppBussinessServiceUrl = "api/v2/creditApplicationBusinessTypes";
 
export async function getBussinessTypeBookServiceData(): Promise<{}> {
    try {
        const response = await request<{}>(credAppBussinessServiceUrl, "GET", {});
        return response;
    } catch (error) {
        console.error("Error calling  API:", error);
        throw new Error("Failed to call Data");
    }
}